module.exports = __webpack_public_path__ + "media/images/icons/country_flags/dk-025c12105396b6e6b3b8ecf1ba953b26.svg";